var _rect, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgB2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 62,
    viewBox: "0 0 62 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 62,
    height: 62,
    rx: 10,
    fill: "#061A11"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4375 27.1945V14.8125C12.4375 14.3649 12.6153 13.9357 12.9318 13.6193C13.2482 13.3028 13.6774 13.125 14.125 13.125H47.875C48.3226 13.125 48.7518 13.3028 49.0682 13.6193C49.3847 13.9357 49.5625 14.3649 49.5625 14.8125V27.1945C49.5625 44.9133 34.5227 50.7773 31.5273 51.7687C31.1871 51.8947 30.8129 51.8947 30.4727 51.7687C27.4773 50.7773 12.4375 44.9133 12.4375 27.1945Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.2812 24.9375L27.8992 36.75L21.7188 30.8438",
    stroke: "#061610",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgB2);
export default __webpack_public_path__ + "static/media/b2.e14db47c57da8963297a2441b1a618e1.svg";
export { ForwardRef as ReactComponent };